/*
 * @Description:
 * @Author: yeqing
 * @Date: 2022-03-23 14:57:17
 * @LastEditTime: 2022-05-12 16:58:37
 * @LastEditors: yeqing
 */

//  专精特新产业数据
export const zjtxOptionData = [
  {
    label: "新一代信息技术",
    children: [
      "移动通信关键设备和宽带光通信传输和接入关键设备",
      "移动通信核心元器件",
      "移动通信终端产品",
      "移动通信网络运营服务",
      "光纤宽带网运营服务",
      "下一代互联网运营服务",
      "新型显示设备及器件",
      "下一代广播电视网运营服务",
      "卫星遥感及卫星通信运营服务",
      "网络与信息安全软件",
      "网络与信息安全服务",
      "数据处理和存储服务",
      "大数据应用与服务",
      "云计算服务",
      "云计算软件",
      "物联网技术和应用服务",
      "高端终端产品",
      "超高清设备研发生产",
    ],
  },
  {
    label: "集成电路",
    children: [
      "集成电路芯片设计",
      "集成电路制造与封装",
      "集成电路材料",
      "集成电路设备",
      "集成电路设计平台及配套IP库开发",
      "电子专用材料",
    ],
  },
  {
    label: "医药健康",
    children: [
      "生物制品制造",
      "基因工程药物和疫苗制造",
      "化学药品新药制剂制造",
      "智能化中药与民族药制造",
      "先进医疗设备及器械制造",
      "植介入生物医用材料及设备制造",
      "其他医疗设备及器械制造",
      "新一代互联网在线问诊平台",
      "新一代互联网协同办公平台",
      "人工智能医学应用软件开发",
      "新一代医疗行业应用软件开发",
      "新兽药、兽药新制剂和兽用生物制品制造"
    ],
  },
  {
    label: "智能装备",
    children: [
      "高端金属制品",
      "交通运输装备",
      "新能源装备",
      "数控机床",
      "数字成型装备",
      "智能仓储物流装备",
      "核心元器件",
      "精密基础元件和传动装置",
      "机器人",
      "增材制造",
      "工程机械",
      "智能制造成套装备",
      "特色智能专用装备",
      "轨道交通",
      "航空航天",
      "高端能源装备",
      "智能传感",
      "智能电网",
      "智能照明",
      "智能控制装置",
      "智能检测与装配装备",
      "科学仪器",
      "高端设备维修"
    ],
  },
  {
    label: "节能环保",
    children: [
      "环境污染处理药剂及材料",
      "环保装备",
      "环保监测",
      "污水再生利用",
      "海水淡化处理",
      "海绵城市建设",
      "环保咨询服务",
      "海洋环境服务",
      "环境评估监测",
      "生态资源监测",
      "高效节能技术推广",
      "先进环保与资源化利用技术推广",
      "水资源循环利用与节水",
      "水污染治理",
      "大气污染治理",
      "固体废物治理",
      "危险废物治理",
      "放射性污染治理",
      "土壤污染治理与修复",
      "噪音污染与振动控制治理",
      "市政设施管理",
      "环境卫生管理"
    ],
  },
  {
    label: "新能源智能汽车",
    children: [
      "新能源智能汽车整车制造",
      "新能源智能汽车改装汽车制造",
      "新能源智能汽车动力总成系统制造",
      "新能源智能汽车关键零部件及配件制造",
      "智能车载设备制造",
      "锂离子电池制造",
      "其他电池制造",
      "新能源智能汽车及零配件批发",
      "新能源智能汽车租赁",
      "新能源智能汽车技术推广服务",
    ],
  },
  {
    label: "新材料",
    children: [
      "高性能膜材料",
      "高性能纤维及制品和复合材料",
      "高分子光、电、磁材料",
      "装配式建筑用新型建材",
      "关键电子材料",
      "高性能纤维及制品和复合材料",
      "纳米材料",
      "先进无机非金属材料",
      "先进有色金属材料",
      "特种陶瓷材料",
      "先进电子材料",
    ],
  },
  {
    label: "人工智能",
    children: [
      "人工智能基础软件",
      "人工智能系统",
      "人工智能平台服务",
      "人工智能芯片",
      "人工智能应用软件",
      "人工智能关键器件",
    ],
  },
  {
    label: "软件和信息服务",
    children: [
      "工业互联网络运营服务",
      "基础软件",
      "工业软件",
      "行业软件",
      "广播电视网络维护及运营支撑软件",
      "信息技术咨询服务",
      "信息系统集成服务",
      "高端信息技术服务支撑软件",
      "区块链软件开发",
      "互联网生产服务平台",
      "互联网生活服务平台",
      "互联网科技创新平台",
      "互联网公共服务平台",
      "数字文化创意软件",
      "数字文化创意内容制作与应用服务",
      "地理信息加工服务",
      "移动计算软件平台",
      "移动应用软件",
      "软件和信息服务",
    ],
  },
  {
    label: "科技服务",
    children: [
      "工程技术服务",
      "研发服务",
      "设计服务",
      "创业孵化服务",
      "知识产权服务",
      "检验检测服务",
      "科技咨询服务",
    ],
  },
  {
    label: "新兴产业",
    children: [
      "云计算",
      "大数据",
      "物联网",
      "车联网（智能汽车）",
      "区块链和5G",
    ],
  },
]